import * as React from 'react'
import * as s from './GraphTooltip.scss'
import { TooltipWithBounds } from '@vx/tooltip'

export const GraphTooltip = ({ children, ...otherProps }) => (
  <TooltipWithBounds {...otherProps} className={s.tooltip}>
    {children}
  </TooltipWithBounds>
)



// WEBPACK FOOTER //
// src/features/CallAnalytics/GraphTooltip/GraphTooltip.tsx